var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeEnabledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.400391 16.436C0.400391 7.59948 7.56383 0.436035 16.4004 0.436035C25.2369 0.436035 32.4004 7.59948 32.4004 16.436C32.4004 25.2726 25.2369 32.436 16.4004 32.436C7.56383 32.436 0.400391 25.2726 0.400391 16.436Z",
    fill: "#4DC45B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06689 16.4362C8.06689 15.5157 8.81309 14.7695 9.73356 14.7695C11.1143 14.7695 12.2336 15.8888 12.2336 17.2695V20.6029C12.2336 21.9836 11.1143 23.1029 9.73356 23.1029C8.81309 23.1029 8.06689 22.3567 8.06689 21.4362V16.4362Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.299 12.5246L19.0771 13.2413C18.8953 13.8286 18.8043 14.1223 18.8743 14.3542C18.9308 14.5418 19.055 14.7036 19.2242 14.81C19.4334 14.9415 19.7498 14.9415 20.3827 14.9415H20.7193C22.861 14.9415 23.9319 14.9415 24.4377 15.5755C24.4955 15.6479 24.5469 15.7249 24.5914 15.8058C24.9805 16.5128 24.5381 17.4653 23.6534 19.3703C22.8415 21.1184 22.4355 21.9925 21.6818 22.507C21.6088 22.5568 21.5338 22.6038 21.457 22.6478C20.6634 23.1027 19.6802 23.1027 17.7137 23.1027H17.2872C14.9048 23.1027 13.7136 23.1027 12.9735 22.3856C12.2334 21.6685 12.2334 20.5143 12.2334 18.206V17.3947C12.2334 16.1816 12.2334 15.575 12.4487 15.0199C12.664 14.4647 13.0762 14.0082 13.9006 13.0953L17.3102 9.31984C17.3957 9.22515 17.4384 9.1778 17.4761 9.14499C17.828 8.83877 18.3711 8.87324 18.6787 9.22132C18.7117 9.25861 18.7477 9.31096 18.8197 9.41565C18.9324 9.57941 18.9888 9.66129 19.0379 9.74241C19.4774 10.4686 19.6104 11.3313 19.4091 12.1503C19.3866 12.2418 19.3574 12.3361 19.299 12.5246Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeEnabledIcon);
export default __webpack_public_path__ + "static/media/like-enabled-icon.f6bc96fe6c8fd5d597430c8d2c450235.svg";
export { ForwardRef as ReactComponent };